var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4501 26.0316C17.9738 27.4627 16.3619 27.2367 14.8102 26.5588C13.1682 25.8658 11.6617 25.8357 9.92932 26.5588C7.76002 27.4928 6.61511 27.2217 5.31956 26.0316C-2.03194 18.4541 -0.947294 6.91463 7.39847 6.49282C9.43219 6.59828 10.8483 7.6076 12.0384 7.69799C13.816 7.33644 15.5183 6.29699 17.4164 6.43257C19.6912 6.61334 21.4085 7.51721 22.5384 9.14419C17.8382 11.9613 18.953 18.1528 23.2615 19.8852C22.4028 22.1449 21.288 24.3895 19.4351 26.0466L19.4501 26.0316ZM11.8877 6.40244C11.6617 3.04304 14.3884 0.271162 17.5219 0C17.9587 3.88666 13.9967 6.77905 11.8877 6.40244Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.4e3b0411d3819b8149f990424058dce3.svg";
export { ForwardRef as ReactComponent };